exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-invoice {\n  margin-left: 10px; }\n  .upload-invoice input[type=file] {\n    display: none; }\n  .upload-invoice .fa.fa-upload:hover {\n    cursor: pointer;\n    color: #34bfa3; }\n  .modal-body {\n  padding-bottom: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/monthly-cut/monthly-cut-detail/investors-monthly-cut/investors-monthly-cut.component.scss
// module id = ../../../../../src/app/theme/pages/aside-left-display-disabled/monthly-cut/monthly-cut-detail/investors-monthly-cut/investors-monthly-cut.component.scss
// module chunks = main